// La jornada de trabajo de una persona: cuantas horas se le piden cada dia de la semana.
//
// Viene de GET /api/jornada (calendario de Odoo) y, si no hay dato fiable, se usa el
// limite por defecto: 8 h de lunes a viernes. Todo aqui es puro: sin red ni React.

// dias: horas exigidas de lunes (0) a domingo (6)
export const JORNADA_DEFECTO = Object.freeze({
  horas_dia: 8, horas_semana: 40, dias: Object.freeze([8, 8, 8, 8, 8, 0, 0]),
  origen: "defecto", motivo_defecto: null,
});

export const jornadaPorDefecto = motivo => ({ ...JORNADA_DEFECTO, dias: [...JORNADA_DEFECTO.dias],
                                             motivo_defecto: motivo || null });

// Lo que llega de la API, o el defecto si no es utilizable. Nunca devuelve algo a medias.
export const normalizarJornada = j => {
  const ok = j && Array.isArray(j.dias) && j.dias.length === 7
    && j.dias.every(h => typeof h === "number" && Number.isFinite(h) && h >= 0 && h <= 24)
    && Number.isFinite(Number(j.horas_semana)) && Number(j.horas_semana) > 0;
  if (!ok) return jornadaPorDefecto(j?.motivo_defecto || "sin datos de la jornada");
  return { horas_dia: Number(j.horas_dia) || 0, horas_semana: Number(j.horas_semana), dias: [...j.dias],
           origen: j.origen === "odoo" ? "odoo" : "defecto", motivo_defecto: j.motivo_defecto || null };
};

// Dia de la semana de una fecha ISO, con el lunes en 0. A mediodia: inmune al cambio de hora.
export const diaSemana = iso => {
  const d = new Date(`${String(iso).slice(0, 10)}T12:00:00`);
  return (d.getDay() + 6) % 7;
};

// Horas que se le piden a esa persona ese dia, antes de festivos y ausencias.
export const objetivoDia = (jornada, iso) => (jornada || JORNADA_DEFECTO).dias[diaSemana(iso)];

// Un dia que no es de trabajo para esa persona (un lunes en un calendario martes-sabado).
export const esNoLaborable = (jornada, iso) => objetivoDia(jornada, iso) === 0;

// "8 h" o "6,5 h"
export const fmtH = h => `${String(Math.round(h * 100) / 100).replace(".", ",")} h`;
